import { useConnect } from '@lore/query-connect';

export default function useQuestionsReal(state, network, schoolStart, schoolEnd, extra = {}, eager = {}) {
  return useConnect('question.find', {
    where: {
      eager: {
        $where: {
          // ...project_networkId(network),
          project: {
            $where: {
              site: {
                $where: {
                  state: {
                    $ilike: state
                  }
                }
              }
            }
          },
          createdAt: {
            $lte: schoolEnd,
            $gte: schoolStart
          },
          request: { $not: 'Outreach' },
          ...extra
        },
        $eager: eager
      }
    },
    pagination: {
      pageSize: 1000
    }
  });
}
